module.exports = __webpack_public_path__ + "static/media/cd.b43f872e.svg";